import { Button, useDisclosure } from '@chakra-ui/react';
import {
	CtrlLogo,
	CtrlSmallLogo,
	RightPaginationArrowIcon,
} from '../../../assets';
import { Fragment } from 'react';
import dealExplorerScreen from '../../../assets/images/deal_explorer_screen.png';
import GuestModal from '../../../modals/Guest/Guest.modal';
import { Link } from 'react-router-dom';

type CruzButtonProps = {
	menuExpanded: boolean;
	hasAccess: boolean;
};

export const CruzButton = ({ menuExpanded, hasAccess }: CruzButtonProps) => {
	const { isOpen, onClose, onOpen } = useDisclosure();

	return (
		<Fragment>
			<Button
				px={'10px'}
				to={hasAccess ? '/cruz-ctrl/dashboard' : '#'}
				onClick={!hasAccess ? onOpen : undefined}
				as={Link}
				h={'48px'}
				_hover={{
					bg: 'blue.200',
				}}
				color={'white'}
				bg={'transparent'}
				justifyContent={'space-between'}>
				{menuExpanded ? (
					<CtrlLogo height={20} width={90} />
				) : (
					<CtrlSmallLogo width={46} />
				)}
				<RightPaginationArrowIcon
					fill={'currentcolor'}
					width={20}
					height={20}
				/>
			</Button>
			<GuestModal
				onClose={onClose}
				isOpen={isOpen}
				title={'Want access'}
				underlineTitle={' to CruzCTRL?'}
				highlightedSubtitle="Join our FREE webinar"
				secondSubtitle=" to gain access"
				buttonName="Go to webinar"
				imageScreen={dealExplorerScreen}
			/>
		</Fragment>
	);
};
